module.exports = __webpack_public_path__ + "fonts/Oswald-VariableFont_wght.a6e5446a.ttf";